"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SiteLayout;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var SiteHeader_1 = require("./SiteHeader");
var SiteFooter_1 = require("./SiteFooter");
function SiteLayout() {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex min-h-screen flex-col bg-background text-foreground", children: [(0, jsx_runtime_1.jsx)(SiteHeader_1.default, {}), (0, jsx_runtime_1.jsx)("main", { className: "flex-1", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }), (0, jsx_runtime_1.jsx)(SiteFooter_1.default, {})] }));
}
